import {
  $ArithmeticOperation,
  $GymMode,
  $JtfMode,
  ArithmeticOperation,
  GymMode,
  JtfMode,
  KnowAndShowCategory,
  KnowAndShowLevel,
} from '@suntex.fim/enums';
import type { SkillSetNumber } from '@suntex.fim/utils';

export type FluencyGameSection = 'gyms' | 'jtf' | 'ks' | 'ss' | 'vif';

export function getFluencyGameSectionPath(
  playerHubPath: string,
  section: FluencyGameSection,
) {
  return `${playerHubPath}/${section}`;
}

export function getGymHubPath(
  playerHubPath: string,
  mode: GymMode,
  operation: ArithmeticOperation,
) {
  const modeSlug = $GymMode.describe(mode).slug;
  const operationSlug = $ArithmeticOperation.describe(operation).slug;

  // K2 gyms sit under the K-2 World area in the hub, not under regular gyms.
  if (mode === GymMode.K2) {
    return `${playerHubPath}/k2/numbers/gym/${operationSlug}`;
  }

  return `${getFluencyGameSectionPath(playerHubPath, 'gyms')}/${modeSlug}/${operationSlug}`;
}

export function getSkillSetHubPath(
  playerHubPath: string,
  skillSet: SkillSetNumber,
) {
  return `${getFluencyGameSectionPath(playerHubPath, 'ss')}/ss-${skillSet}`;
}

export function getKnowAndShowGamePath(
  level: KnowAndShowLevel,
  category: KnowAndShowCategory,
) {
  return `/modules/word-problems/${level}/${category}`;
}

export function getVifGamePath(operation: ArithmeticOperation) {
  const operationSlug = $ArithmeticOperation.describe(operation).slug;

  return `/modules/vif/${operationSlug}`;
}

export function getJtfGamePath(mode: JtfMode, operation: ArithmeticOperation) {
  const modeSlug = $JtfMode.describe(mode).slug;
  const operationSlug = $ArithmeticOperation.describe(operation).slug;

  return `/modules/just-the-facts/${modeSlug}/${operationSlug}`;
}
